(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire46a9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire46a9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jU1Wv", function(module, exports) {

var $l8I3q = parcelRequire("l8I3q");
const $9cf00ee2bbca7138$var$CART_FETCH_TIMEOUT_MS = 8000;
const $9cf00ee2bbca7138$var$WISHLIST_ITEM_SELECTOR = ".swym-wishlist-item";
const $9cf00ee2bbca7138$var$SKU_PROPERTY_LABEL_FALLBACK = "Product Code";
const $9cf00ee2bbca7138$var$SPECIAL_ORDER_TAG_LABEL = "Special Order";
const $9cf00ee2bbca7138$var$SPECIAL_ORDER_PROPERTY_KEY = "_special_order";
const $9cf00ee2bbca7138$var$getSkuPropertyLabel = ()=>{
    const container = document.getElementById("swym-wishlist-render-container");
    if (!(container instanceof HTMLElement)) return $9cf00ee2bbca7138$var$SKU_PROPERTY_LABEL_FALLBACK;
    const fromDataset = container.dataset.labelSku?.trim() ?? "";
    return fromDataset || $9cf00ee2bbca7138$var$SKU_PROPERTY_LABEL_FALLBACK;
};
const $9cf00ee2bbca7138$var$fetchJson = (url)=>{
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), $9cf00ee2bbca7138$var$CART_FETCH_TIMEOUT_MS);
    return fetch(url, {
        signal: controller.signal
    }).then((response)=>response.ok ? response.json() : null).catch(()=>null).finally(()=>clearTimeout(timeoutId));
};
const $9cf00ee2bbca7138$var$updateCartItemSkuProperty = async (wishlistItemElement)=>{
    if (!(wishlistItemElement instanceof HTMLElement)) return false;
    const rawVariantId = wishlistItemElement.dataset.variantId?.trim() ?? "";
    const sku = wishlistItemElement.dataset.sku?.trim() ?? "";
    if (!rawVariantId || !sku) return false;
    const numericVariantId = Number(rawVariantId);
    if (!Number.isFinite(numericVariantId)) return false;
    const cart = await $9cf00ee2bbca7138$var$fetchJson("/cart.js");
    const items = cart?.items;
    if (!items?.length) return false;
    const targetItems = items.filter((item)=>item.variant_id === numericVariantId);
    if (!targetItems.length) return false;
    const specialOrderValue = await $9cf00ee2bbca7138$var$getSpecialOrderPropertyValue(wishlistItemElement);
    const skuPropertyLabel = $9cf00ee2bbca7138$var$getSkuPropertyLabel();
    const updatePayloads = targetItems.reduce((accumulator, targetItem)=>{
        const existingProperties = targetItem.properties;
        const currentSkuRaw = existingProperties && existingProperties[skuPropertyLabel] ? existingProperties[skuPropertyLabel] : null;
        const currentSku = typeof currentSkuRaw === "string" ? currentSkuRaw.trim() : "";
        if (currentSku === sku) return accumulator;
        const properties = {};
        if (existingProperties) for(const key in existingProperties){
            if (!Object.prototype.hasOwnProperty.call(existingProperties, key)) continue;
            if (key === "SKU" || key === skuPropertyLabel) continue;
            const value = existingProperties[key];
            if (typeof value === "string" && value.trim()) properties[key] = value;
        }
        properties[skuPropertyLabel] = sku;
        if (specialOrderValue) properties[$9cf00ee2bbca7138$var$SPECIAL_ORDER_PROPERTY_KEY] = specialOrderValue;
        accumulator.push({
            id: targetItem.key,
            quantity: targetItem.quantity,
            properties: properties
        });
        return accumulator;
    }, []);
    if (!updatePayloads.length) return false;
    try {
        await Promise.all(updatePayloads.map((payload)=>fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify(payload)
            })));
        return true;
    } catch  {
        // eslint-disable-next-line no-console
        console.error("Failed to update cart item properties");
    }
    return false;
};
const $9cf00ee2bbca7138$var$getSoldOutLabel = ()=>{
    const body = document.body;
    if (!body) return "";
    const { labelSoldOut: labelSoldOut } = body.dataset;
    return labelSoldOut ?? "";
};
const $9cf00ee2bbca7138$var$disableQfcUnavailableButton = (button)=>{
    if (button.dataset.qfcAvailability === "unavailable") return;
    button.disabled = true;
    button.dataset.qfcAvailability = "unavailable";
    button.setAttribute("aria-disabled", "true");
    const soldOutLabel = $9cf00ee2bbca7138$var$getSoldOutLabel();
    if (soldOutLabel.length > 0) {
        const applyLabel = ()=>{
            if (button.textContent !== soldOutLabel) button.textContent = soldOutLabel;
            button.setAttribute("aria-label", soldOutLabel);
        };
        applyLabel();
        const labelObserver = new MutationObserver(()=>{
            if (button.dataset.qfcAvailability !== "unavailable") {
                labelObserver.disconnect();
                return;
            }
            applyLabel();
        });
        labelObserver.observe(button, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }
};
const $9cf00ee2bbca7138$var$getQfcAvailabilityUrl = (button)=>{
    const wishlistItem = button.closest($9cf00ee2bbca7138$var$WISHLIST_ITEM_SELECTOR);
    const detailContainer = button.closest(".swym-wishlist-product-detail-text-container");
    const root = wishlistItem ?? detailContainer;
    if (!root) return "";
    const link = root.querySelector(".swym-wishlist-image-wrapper") ?? root.querySelector(".swym-more-details-btn");
    if (!link) return "";
    const href = link.getAttribute("href");
    if (!href) return "";
    let productUrl;
    try {
        productUrl = href.startsWith("http") ? new URL(href) : new URL(href, window.location.origin);
    } catch (_error) {
        return "";
    }
    const variantId = productUrl.searchParams.get("variant");
    if (!variantId) return "";
    const availabilityUrl = new URL(productUrl.pathname, productUrl.origin || window.location.origin);
    availabilityUrl.searchParams.set("variant", variantId);
    availabilityUrl.searchParams.set("view", "qfc-availability");
    return availabilityUrl.toString();
};
const $9cf00ee2bbca7138$var$initializedButtons = new WeakSet();
const $9cf00ee2bbca7138$var$updateWishlistButtonAvailability = async (button)=>{
    if (button.dataset.qfcAvailability === "unavailable") return;
    const availabilityUrl = $9cf00ee2bbca7138$var$getQfcAvailabilityUrl(button);
    if (!availabilityUrl) return;
    try {
        const response = await fetch(availabilityUrl);
        if (!response.ok) return;
        const availability = await response.json();
        if (!availability.isVariantAvailable) $9cf00ee2bbca7138$var$disableQfcUnavailableButton(button);
    } catch (_error) {
        // eslint-disable-next-line no-console
        console.error("QFC availability check failed");
    }
};
const $9cf00ee2bbca7138$var$getSpecialOrderPropertyValue = async (wishlistItemElement)=>{
    const cached = wishlistItemElement.dataset.specialOrder;
    if (cached === "true") return "true";
    if (cached === "false") return null;
    const handle = $9cf00ee2bbca7138$var$extractHandleFromContext(wishlistItemElement);
    if (!handle) {
        wishlistItemElement.dataset.specialOrder = "false";
        return null;
    }
    const product = await $9cf00ee2bbca7138$var$fetchJson(`/products/${encodeURIComponent(handle)}.js`);
    const tags = product?.tags;
    if (!tags || !tags.length) {
        wishlistItemElement.dataset.specialOrder = "false";
        return null;
    }
    const expectedTag = $9cf00ee2bbca7138$var$normalizeTag($9cf00ee2bbca7138$var$SPECIAL_ORDER_TAG_LABEL);
    const hasSpecialOrder = tags.some((tag)=>!!tag && $9cf00ee2bbca7138$var$normalizeTag(tag) === expectedTag);
    wishlistItemElement.dataset.specialOrder = hasSpecialOrder ? "true" : "false";
    return hasSpecialOrder ? "true" : null;
};
const $9cf00ee2bbca7138$var$SCHOOL_TAG_FALLBACK = "school";
const $9cf00ee2bbca7138$var$WISHLIST_ADD_TO_CART_BUTTON_SELECTOR = ".swym-add-to-cart-btn, .swym-wishlist-add-to-cart-btn";
const $9cf00ee2bbca7138$var$WISHLIST_IMAGE_LINK_SELECTOR = "a.swym-wishlist-image-wrapper";
const $9cf00ee2bbca7138$var$WISHLIST_DETAIL_SELECTOR = ".swym-wishlist-product-detail-content";
const $9cf00ee2bbca7138$var$WISHLIST_DETAIL_LINK_SELECTOR = ".swym-more-details-btn.swym-is-anchor";
const $9cf00ee2bbca7138$var$getQuoteConfig = ()=>{
    const config = window.carbatecSchoolQuote;
    if (!config || !config.url || !config.label) return null;
    return {
        url: config.url,
        label: config.label,
        tag: config.tag || $9cf00ee2bbca7138$var$SCHOOL_TAG_FALLBACK
    };
};
const $9cf00ee2bbca7138$var$normalizeTag = (value)=>value.trim().toLowerCase();
const $9cf00ee2bbca7138$var$hasSchoolTag = (tags, schoolTag)=>{
    const expected = $9cf00ee2bbca7138$var$normalizeTag(schoolTag || $9cf00ee2bbca7138$var$SCHOOL_TAG_FALLBACK);
    return tags.some((tag)=>tag && $9cf00ee2bbca7138$var$normalizeTag(tag) === expected);
};
const $9cf00ee2bbca7138$var$extractHandleFromHref = (href)=>{
    try {
        const url = new URL(href, window.location.origin);
        const segments = url.pathname.split("/");
        const productsIndex = segments.indexOf("products");
        if (productsIndex === -1) return null;
        const handle = segments[productsIndex + 1] || "";
        return handle || null;
    } catch  {
        return null;
    }
};
const $9cf00ee2bbca7138$var$extractHandleFromContext = (context)=>{
    const imageLink = context.querySelector($9cf00ee2bbca7138$var$WISHLIST_IMAGE_LINK_SELECTOR);
    const detailsLink = context.querySelector($9cf00ee2bbca7138$var$WISHLIST_DETAIL_LINK_SELECTOR);
    const link = imageLink instanceof HTMLAnchorElement ? imageLink : detailsLink instanceof HTMLAnchorElement ? detailsLink : null;
    if (!link) return null;
    return $9cf00ee2bbca7138$var$extractHandleFromHref(link.href);
};
const $9cf00ee2bbca7138$var$attachSchoolLabelObserver = (button, label)=>{
    if (button.dataset.schoolLabelBound === "true") return;
    button.dataset.schoolLabelBound = "true";
    button.dataset.schoolLabel = label;
    const observer = new MutationObserver(()=>{
        const expectedLabel = button.dataset.schoolLabel;
        if (!expectedLabel) return;
        if (button.textContent === expectedLabel) return;
        button.textContent = expectedLabel;
    });
    observer.observe(button, {
        childList: true,
        characterData: true,
        subtree: true
    });
};
const $9cf00ee2bbca7138$var$markButtonIfSchool = (button, config)=>{
    const gridItem = button.closest($9cf00ee2bbca7138$var$WISHLIST_ITEM_SELECTOR);
    const detailItem = button.closest($9cf00ee2bbca7138$var$WISHLIST_DETAIL_SELECTOR);
    const contextElement = gridItem ?? detailItem;
    if (!(contextElement instanceof HTMLElement)) return;
    if (contextElement.dataset.schoolChecked === "true") return;
    const handle = $9cf00ee2bbca7138$var$extractHandleFromContext(contextElement);
    if (!handle) {
        contextElement.dataset.schoolChecked = "true";
        return;
    }
    fetch(`/products/${encodeURIComponent(handle)}.js`).then((response)=>response.ok ? response.json() : null).then((data)=>{
        contextElement.dataset.schoolChecked = "true";
        if (!data || !Array.isArray(data.tags)) return;
        if (!$9cf00ee2bbca7138$var$hasSchoolTag(data.tags, config.tag)) return;
        button.dataset.schoolProduct = "true";
        button.textContent = config.label;
        button.setAttribute("aria-label", config.label);
        $9cf00ee2bbca7138$var$attachSchoolLabelObserver(button, config.label);
    }).catch(()=>{
        contextElement.dataset.schoolChecked = "true";
    });
};
const $9cf00ee2bbca7138$var$handleButtonClick = (button)=>{
    if (button.dataset.schoolProduct === "true") return;
    const wishlistItemElement = button.closest($9cf00ee2bbca7138$var$WISHLIST_ITEM_SELECTOR);
    const isCartDrawerElement = (element)=>{
        return !!element && "open" in element;
    };
    const syncSkuAndCartDrawer = (delays)=>{
        if (!delays.length) return;
        const [delay, ...nextDelays] = delays;
        window.setTimeout(()=>{
            (async ()=>{
                const didUpdate = await $9cf00ee2bbca7138$var$updateCartItemSkuProperty(wishlistItemElement);
                if (!didUpdate) {
                    syncSkuAndCartDrawer(nextDelays);
                    return;
                }
                const cartDrawer = document.querySelector("cart-drawer");
                if (!isCartDrawerElement(cartDrawer)) return;
                await (0, $l8I3q.updateElements)([
                    ".drawer__inner",
                    ".cart-count-bubble"
                ]);
                cartDrawer.classList.remove("is-empty");
                cartDrawer.open();
            })();
        }, delay);
    };
    syncSkuAndCartDrawer([
        0,
        400,
        1200,
        3000
    ]);
};
const $9cf00ee2bbca7138$var$findAndHandleButtons = ()=>{
    const buttons = document.querySelectorAll($9cf00ee2bbca7138$var$WISHLIST_ADD_TO_CART_BUTTON_SELECTOR);
    if (!buttons.length) return;
    const quoteConfig = $9cf00ee2bbca7138$var$getQuoteConfig();
    buttons.forEach((button)=>{
        if (quoteConfig) $9cf00ee2bbca7138$var$markButtonIfSchool(button, quoteConfig);
    });
};
const $9cf00ee2bbca7138$var$handleWishlistAddToCart = ()=>{
    const applyToButtons = ()=>{
        const buttons = document.querySelectorAll($9cf00ee2bbca7138$var$WISHLIST_ADD_TO_CART_BUTTON_SELECTOR);
        buttons.forEach((button)=>{
            if ($9cf00ee2bbca7138$var$initializedButtons.has(button)) return;
            $9cf00ee2bbca7138$var$initializedButtons.add(button);
            button.addEventListener("click", ()=>$9cf00ee2bbca7138$var$handleButtonClick(button));
            $9cf00ee2bbca7138$var$updateWishlistButtonAvailability(button);
        });
    };
    const mainObserver = new MutationObserver(()=>{
        applyToButtons();
        $9cf00ee2bbca7138$var$findAndHandleButtons();
    });
    mainObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    applyToButtons();
    $9cf00ee2bbca7138$var$findAndHandleButtons();
};
const $9cf00ee2bbca7138$var$handleWishlistQuoteClick = (event)=>{
    const quoteConfig = $9cf00ee2bbca7138$var$getQuoteConfig();
    if (!quoteConfig) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest($9cf00ee2bbca7138$var$WISHLIST_ADD_TO_CART_BUTTON_SELECTOR);
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.dataset.schoolProduct !== "true") return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    window.location.href = quoteConfig.url;
};
const $9cf00ee2bbca7138$var$initWishlistHandlers = ()=>{
    $9cf00ee2bbca7138$var$handleWishlistAddToCart();
    document.addEventListener("click", $9cf00ee2bbca7138$var$handleWishlistQuoteClick, true);
};
$9cf00ee2bbca7138$var$initWishlistHandlers();

});
parcelRegister("l8I3q", function(module, exports) {

$parcel$export(module.exports, "updateElements", () => $07d5380be57d91f1$export$c5303087167e431c);
const $07d5380be57d91f1$export$c5303087167e431c = async (selectors, sectionId)=>{
    try {
        const response = await fetch(sectionId ? `?sections=${sectionId}` : location.href);
        const html = sectionId ? (await response.json())[sectionId] : await response.text();
        const newdoc = new DOMParser().parseFromString(html, "text/html");
        if (typeof selectors === "string") selectors = [
            selectors
        ];
        for (const selector of selectors){
            const elements = document.querySelectorAll(selector);
            const newElements = newdoc.querySelectorAll(selector);
            if (elements.length !== newElements.length) throw new Error("Elements count mismatch for: " + selector);
            elements.forEach((element, index)=>{
                const newElement = newElements[index];
                if (element && newElement) element.outerHTML = newElement.outerHTML;
            });
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error({
            error: error
        });
    }
};

});


parcelRegister("e0FTq", function(module, exports) {
document.addEventListener("click", (event)=>{
    if (event.target instanceof HTMLElement) {
        const isPaginationItem = event.target.closest(".pagination__item");
        if (isPaginationItem) {
            const productGridContainer = document.querySelector(".product-grid-container");
            if (productGridContainer) {
                const header = document.querySelector("header");
                const headerHeight = header ? header.offsetHeight : 0;
                const elementPosition = productGridContainer.getBoundingClientRect().top + window.pageYOffset - headerHeight - 40;
                window.scrollTo({
                    top: elementPosition,
                    behavior: "smooth"
                });
            } else window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }
});

});

parcelRegister("6R7pS", function(module, exports) {
function $5e9671ce07f3b44c$var$initRepairNetwork(componentNode) {
    if (!(componentNode instanceof HTMLElement)) return;
    if (componentNode.dataset.repairNetworkBound === "true") return;
    componentNode.dataset.repairNetworkBound = "true";
    const repairSelect = componentNode.querySelector("[data-repair-network-select]");
    if (!(repairSelect instanceof HTMLSelectElement)) return;
    const cardNodes = Array.from(componentNode.querySelectorAll("[data-repair-network-item]"));
    const repairCards = cardNodes.filter((node)=>node instanceof HTMLElement).map((element)=>({
            element: element,
            key: element.dataset.key ?? ""
        }));
    const showSelectedByKey = (selectedKey)=>{
        repairCards.forEach(({ element: element, key: key })=>{
            if (key === selectedKey) element.removeAttribute("hidden");
            else element.setAttribute("hidden", "hidden");
        });
    };
    repairSelect.addEventListener("change", ()=>showSelectedByKey(repairSelect.value));
    showSelectedByKey(repairSelect.value);
}
function $5e9671ce07f3b44c$var$mountRepairNetworksIn(rootNode) {
    Array.from(rootNode.querySelectorAll("[data-repair-network]")).forEach($5e9671ce07f3b44c$var$initRepairNetwork);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>$5e9671ce07f3b44c$var$mountRepairNetworksIn(document));
else $5e9671ce07f3b44c$var$mountRepairNetworksIn(document);
document.addEventListener("shopify:section:load", (event)=>{
    const targetNode = event.target;
    if (targetNode instanceof HTMLElement) $5e9671ce07f3b44c$var$mountRepairNetworksIn(targetNode);
});

});

parcelRegister("695Bn", function(module, exports) {
const $06e543d4b42faeb6$var$SEARCHSPRING_ROOT_ID = "searchspring-content";
const $06e543d4b42faeb6$var$SPECIAL_ORDER_TAG_NORMALIZED = "special order";
const $06e543d4b42faeb6$var$PRODUCT_LINK_SELECTOR = "a[href*='/products/']";
const $06e543d4b42faeb6$var$specialOrderCache = {};
const $06e543d4b42faeb6$var$extractHandleFromHref = (href)=>{
    try {
        const url = new URL(href, window.location.origin);
        const segments = url.pathname.split("/");
        const productsIndex = segments.indexOf("products");
        if (productsIndex === -1) return null;
        const handle = segments[productsIndex + 1] || "";
        return handle || null;
    } catch  {
        return null;
    }
};
const $06e543d4b42faeb6$var$findProductHandleForForm = (form)=>{
    let current = form;
    while(current && current.id !== $06e543d4b42faeb6$var$SEARCHSPRING_ROOT_ID){
        const link = current.querySelector($06e543d4b42faeb6$var$PRODUCT_LINK_SELECTOR);
        if (link) return $06e543d4b42faeb6$var$extractHandleFromHref(link.href);
        current = current.parentElement;
    }
    return null;
};
const $06e543d4b42faeb6$var$fetchIsSpecialOrder = async (handle)=>{
    const cached = $06e543d4b42faeb6$var$specialOrderCache[handle];
    if (cached !== undefined) return cached;
    try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) {
            $06e543d4b42faeb6$var$specialOrderCache[handle] = false;
            return false;
        }
        const data = await response.json();
        const tags = Array.isArray(data.tags) ? data.tags : [];
        const isSpecialOrder = tags.some((tag)=>tag && tag.trim().toLowerCase() === $06e543d4b42faeb6$var$SPECIAL_ORDER_TAG_NORMALIZED);
        $06e543d4b42faeb6$var$specialOrderCache[handle] = isSpecialOrder;
        return isSpecialOrder;
    } catch  {
        $06e543d4b42faeb6$var$specialOrderCache[handle] = false;
        return false;
    }
};
const $06e543d4b42faeb6$var$ensureSpecialOrderInput = (form)=>{
    const existingInput = form.querySelector('input[name="properties[_special_order]"]');
    if (existingInput) return;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[_special_order]";
    input.value = "true";
    form.append(input);
};
const $06e543d4b42faeb6$var$prepareFormIfSpecialOrderOnSubmit = async (form)=>{
    const handle = $06e543d4b42faeb6$var$findProductHandleForForm(form);
    if (!handle) return;
    const isSpecialOrder = await $06e543d4b42faeb6$var$fetchIsSpecialOrder(handle);
    if (!isSpecialOrder) return;
    $06e543d4b42faeb6$var$ensureSpecialOrderInput(form);
};
const $06e543d4b42faeb6$var$initSearchspringSpecialOrder = ()=>{
    document.addEventListener("click", (event)=>{
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        const submitButton = target.closest('button[type="submit"]') ?? target.closest('input[type="submit"]');
        if (!submitButton) return;
        const form = submitButton.form ?? submitButton.closest("form");
        if (!form) return;
        const root = document.getElementById($06e543d4b42faeb6$var$SEARCHSPRING_ROOT_ID);
        if (!root || !root.contains(form)) return;
        if (!form.querySelector('input[name="id"]')) return;
        event.preventDefault();
        event.stopPropagation();
        const submitForm = ()=>{
            if (typeof form.requestSubmit === "function") form.requestSubmit(submitButton);
            else form.submit();
        };
        (async ()=>{
            try {
                await $06e543d4b42faeb6$var$prepareFormIfSpecialOrderOnSubmit(form);
            } finally{
                submitForm();
            }
        })();
    }, true);
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $06e543d4b42faeb6$var$initSearchspringSpecialOrder);
else $06e543d4b42faeb6$var$initSearchspringSpecialOrder();

});

parcelRegister("9ei6z", function(module, exports) {
const $19e307b0da6eeb4e$var$SEARCHSPRING_ROOT_ID = "searchspring-content";
const $19e307b0da6eeb4e$var$PRODUCT_LINK_SELECTOR = "a[href*='/products/']";
const $19e307b0da6eeb4e$var$extractHandleFromHref = (href)=>{
    try {
        const url = new URL(href, window.location.origin);
        const segments = url.pathname.split("/");
        const productsIndex = segments.indexOf("products");
        if (productsIndex === -1) return null;
        const handle = segments[productsIndex + 1] || "";
        return handle || null;
    } catch  {
        return null;
    }
};
const $19e307b0da6eeb4e$var$findProductHandleForForm = (form)=>{
    const directLink = form.querySelector($19e307b0da6eeb4e$var$PRODUCT_LINK_SELECTOR);
    if (directLink) return $19e307b0da6eeb4e$var$extractHandleFromHref(directLink.href);
    let current = form.parentElement;
    while(current && current.id !== $19e307b0da6eeb4e$var$SEARCHSPRING_ROOT_ID){
        const link = current.querySelector($19e307b0da6eeb4e$var$PRODUCT_LINK_SELECTOR);
        if (link) return $19e307b0da6eeb4e$var$extractHandleFromHref(link.href);
        current = current.parentElement;
    }
    return null;
};
const $19e307b0da6eeb4e$var$fetchProduct = async (handle)=>{
    try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) return null;
        const data = await response.json();
        return data;
    } catch  {
        return null;
    }
};
const $19e307b0da6eeb4e$var$findVariantSku = (product, variantIdRaw)=>{
    const variants = product?.variants;
    if (!variants || !variants.length) return null;
    const numericVariantId = Number(variantIdRaw);
    if (!Number.isFinite(numericVariantId)) return null;
    const rawSku = variants.find((variant)=>variant.id === numericVariantId)?.sku;
    const trimmed = rawSku?.trim() ?? "";
    return trimmed || null;
};
const $19e307b0da6eeb4e$var$getSkuPropertyLabel = ()=>{
    const root = document.getElementById($19e307b0da6eeb4e$var$SEARCHSPRING_ROOT_ID);
    if (!(root instanceof HTMLElement)) return "SKU";
    const fromDataset = root.dataset.labelSkuPair?.trim() ?? root.dataset.labelSku?.trim() ?? "";
    return fromDataset || "SKU";
};
const $19e307b0da6eeb4e$var$ensureSkuPropertyInput = (form, label, sku)=>{
    const trimmedSku = sku.trim();
    if (!trimmedSku) return;
    const name = `properties[${label}]`;
    const existingInput = form.querySelector(`input[name="${name}"]`);
    if (existingInput) {
        existingInput.value = trimmedSku;
        existingInput.disabled = false;
        return;
    }
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = trimmedSku;
    form.append(input);
};
const $19e307b0da6eeb4e$var$enhanceFormBeforeSubmit = async (form)=>{
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    const variantIdRaw = idInput.value.trim();
    if (!variantIdRaw) return;
    const handle = $19e307b0da6eeb4e$var$findProductHandleForForm(form);
    if (!handle) return;
    const product = await $19e307b0da6eeb4e$var$fetchProduct(handle);
    const sku = $19e307b0da6eeb4e$var$findVariantSku(product, variantIdRaw);
    if (!sku) return;
    const label = $19e307b0da6eeb4e$var$getSkuPropertyLabel();
    $19e307b0da6eeb4e$var$ensureSkuPropertyInput(form, label, sku);
    if (label !== "SKU") {
        const legacyInput = form.querySelector('input[name="properties[SKU]"]');
        if (legacyInput) legacyInput.remove();
    }
};
const $19e307b0da6eeb4e$var$initSearchspringAddToCartSku = ()=>{
    document.addEventListener("click", (event)=>{
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        const submitButton = target.closest('button[type="submit"]') ?? target.closest('input[type="submit"]');
        if (!submitButton) return;
        const form = submitButton.form ?? submitButton.closest("form");
        if (!form) return;
        const root = document.getElementById($19e307b0da6eeb4e$var$SEARCHSPRING_ROOT_ID);
        if (!root || !root.contains(form)) return;
        const idInput = form.querySelector('input[name="id"]');
        if (!idInput) return;
        event.preventDefault();
        event.stopPropagation();
        const submitForm = ()=>{
            if (typeof form.requestSubmit === "function") form.requestSubmit(submitButton);
            else form.submit();
        };
        (async ()=>{
            try {
                await $19e307b0da6eeb4e$var$enhanceFormBeforeSubmit(form);
            } finally{
                submitForm();
            }
        })();
    }, true);
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $19e307b0da6eeb4e$var$initSearchspringAddToCartSku);
else $19e307b0da6eeb4e$var$initSearchspringAddToCartSku();

});

parcelRegister("aKoSb", function(module, exports) {
const $9fa85180a8f52b36$var$ROOT_SELECTOR = "[data-ss-recommendations-root]";
const $9fa85180a8f52b36$var$CARD_SELECTOR = ".card-wrapper.product-card-wrapper";
const $9fa85180a8f52b36$var$initSwym = (selector)=>{
    const run = ()=>window._swat?.initializeActionButtons(selector);
    if (window._swat?.initializeActionButtons) run();
    else (window.SwymCallbacks = window.SwymCallbacks || []).push(run);
};
document.querySelectorAll($9fa85180a8f52b36$var$ROOT_SELECTOR).forEach((root)=>{
    const id = root.dataset.ssSectionId;
    if (!id) return;
    const selector = `[data-ss-section-id="${id}"]`;
    if (root.querySelector($9fa85180a8f52b36$var$CARD_SELECTOR)) return $9fa85180a8f52b36$var$initSwym(selector);
    const observer = new MutationObserver(()=>{
        if (!root.querySelector($9fa85180a8f52b36$var$CARD_SELECTOR)) return;
        observer.disconnect();
        $9fa85180a8f52b36$var$initSwym(selector);
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
});

});

parcelRequire("jU1Wv");
parcelRequire("e0FTq");
parcelRequire("6R7pS");
const $cd2df92b128184fc$var$TOGGLE_SELECTOR = ".category-slider__description-toggle";
const $cd2df92b128184fc$var$COLLAPSIBLE_CLASS = "is-collapsible";
const $cd2df92b128184fc$var$OPEN_CLASS = "is-open";
const $cd2df92b128184fc$var$btn = document.querySelector($cd2df92b128184fc$var$TOGGLE_SELECTOR);
if ($cd2df92b128184fc$var$btn instanceof HTMLButtonElement) {
    $cd2df92b128184fc$var$btn.classList.add("is-ready");
    const id = $cd2df92b128184fc$var$btn.getAttribute("aria-controls");
    const wrap = id ? document.getElementById(id) : null;
    if (wrap) {
        wrap.classList.add($cd2df92b128184fc$var$COLLAPSIBLE_CLASS);
        const expanded = $cd2df92b128184fc$var$btn.getAttribute("aria-expanded") === "true";
        wrap.setAttribute("aria-hidden", String(!expanded));
        if (expanded) {
            wrap.classList.add($cd2df92b128184fc$var$OPEN_CLASS);
            wrap.style.maxHeight = `${wrap.scrollHeight}px`;
        }
        $cd2df92b128184fc$var$btn.addEventListener("click", ()=>{
            const isExpanded = $cd2df92b128184fc$var$btn.getAttribute("aria-expanded") === "true";
            if (!isExpanded) {
                $cd2df92b128184fc$var$btn.setAttribute("aria-expanded", "true");
                wrap.classList.add($cd2df92b128184fc$var$OPEN_CLASS);
                wrap.setAttribute("aria-hidden", "false");
                requestAnimationFrame(()=>{
                    wrap.style.maxHeight = `${wrap.scrollHeight}px`;
                });
            } else {
                $cd2df92b128184fc$var$btn.setAttribute("aria-expanded", "false");
                wrap.style.maxHeight = `${wrap.scrollHeight}px`;
                requestAnimationFrame(()=>{
                    wrap.classList.remove($cd2df92b128184fc$var$OPEN_CLASS);
                    wrap.setAttribute("aria-hidden", "true");
                    wrap.style.maxHeight = "";
                });
            }
            const labelMore = $cd2df92b128184fc$var$btn.dataset.labelMore;
            const labelLess = $cd2df92b128184fc$var$btn.dataset.labelLess;
            const span = $cd2df92b128184fc$var$btn.querySelector("span");
            if (span && labelMore && labelLess) span.textContent = isExpanded ? labelMore : labelLess;
        });
    }
}


const $7d1b13016aa3d0bd$var$PERCENTAGE_OFF_TAG = "percentage-off-sale";
const $7d1b13016aa3d0bd$var$SPECIAL_ORDER_TAG = "special-order";
const $7d1b13016aa3d0bd$var$UNKNOWN_LOCATION_RANK = 10;
const $7d1b13016aa3d0bd$var$DEFAULT_PRIORITY = 100;
const $7d1b13016aa3d0bd$var$cachedTagsConfigBySiteId = new Map();
async function $7d1b13016aa3d0bd$export$8545333153626f43(siteId, fetchJson) {
    const normalizedSiteId = siteId;
    if (!normalizedSiteId) return null;
    const cached = $7d1b13016aa3d0bd$var$cachedTagsConfigBySiteId.get(normalizedSiteId);
    if (cached !== undefined) return cached;
    const url = `https://${normalizedSiteId}.a.searchspring.io/api/meta/meta?siteId=${normalizedSiteId}`;
    let data;
    try {
        data = await fetchJson(url);
    } catch  {
        return null;
    }
    const rawTagsConfig = data?.badges?.tags;
    const tagsConfig = rawTagsConfig && typeof rawTagsConfig === "object" && !Array.isArray(rawTagsConfig) ? rawTagsConfig : null;
    $7d1b13016aa3d0bd$var$cachedTagsConfigBySiteId.set(normalizedSiteId, tagsConfig);
    return tagsConfig;
}
function $7d1b13016aa3d0bd$var$getLocationRank(location) {
    if (location === "callout") return 0;
    if (location === "left") return 1;
    if (location === "right") return 2;
    return $7d1b13016aa3d0bd$var$UNKNOWN_LOCATION_RANK;
}
function $7d1b13016aa3d0bd$export$1a6553668c5e7a2c(containerElement, badges, tagsConfig) {
    const normalizedBadges = badges.map((badge, index)=>({
            index: index,
            tag: typeof badge.tag === "string" ? badge.tag.trim() : "",
            value: typeof badge.value === "string" ? badge.value.trim() : ""
        }));
    const hasPercentageOff = normalizedBadges.some((badge)=>badge.tag === $7d1b13016aa3d0bd$var$PERCENTAGE_OFF_TAG);
    const filteredBadges = normalizedBadges.filter((badge)=>{
        if (!badge.tag && !badge.value) return false;
        if (badge.tag === "sale" && hasPercentageOff) return false;
        if (badge.tag === $7d1b13016aa3d0bd$var$SPECIAL_ORDER_TAG) return false;
        if (badge.value.toLowerCase().includes("special order")) return false;
        if (!tagsConfig || !badge.tag) return true;
        return tagsConfig[badge.tag]?.enabled !== false;
    });
    if (!filteredBadges.length) return;
    if (tagsConfig) filteredBadges.sort((leftBadge, rightBadge)=>{
        const leftConfig = tagsConfig[leftBadge.tag];
        const rightConfig = tagsConfig[rightBadge.tag];
        const leftLocationRank = $7d1b13016aa3d0bd$var$getLocationRank(leftConfig?.location?.split("/")[0]);
        const rightLocationRank = $7d1b13016aa3d0bd$var$getLocationRank(rightConfig?.location?.split("/")[0]);
        if (leftLocationRank !== rightLocationRank) return leftLocationRank - rightLocationRank;
        const leftPriority = typeof leftConfig?.priority === "number" ? leftConfig.priority : $7d1b13016aa3d0bd$var$DEFAULT_PRIORITY;
        const rightPriority = typeof rightConfig?.priority === "number" ? rightConfig.priority : $7d1b13016aa3d0bd$var$DEFAULT_PRIORITY;
        if (leftPriority !== rightPriority) return leftPriority - rightPriority;
        return leftBadge.index - rightBadge.index;
    });
    const fragment = document.createDocumentFragment();
    for (const badge of filteredBadges){
        const { tag: tag, value: value } = badge;
        const badgeWrapper = document.createElement("div");
        const wrapperClasses = [
            "card__badge",
            "top"
        ];
        if (tagsConfig && tag) {
            const location = tagsConfig[tag]?.location;
            const locationKey = location?.split("/")[0] ?? "";
            if (locationKey === "right") wrapperClasses.push("right");
        }
        badgeWrapper.className = wrapperClasses.join(" ");
        const badgeLabel = document.createElement("span");
        badgeLabel.className = tagsConfig ? "ss-pdp-badge" : "ss-pdp-badge-default";
        const parameters = tagsConfig?.[tag]?.parameters;
        if (parameters?.colorText) badgeLabel.style.color = parameters.colorText;
        if (parameters?.color) badgeLabel.style.backgroundColor = parameters.color;
        const imageUrl = parameters?.url;
        if (imageUrl) {
            const image = document.createElement("img");
            image.className = "ss-pdp-badge-img";
            image.src = imageUrl;
            image.alt = value || tag;
            badgeLabel.textContent = "";
            badgeLabel.append(image);
        } else badgeLabel.textContent = tag === $7d1b13016aa3d0bd$var$PERCENTAGE_OFF_TAG && value ? `${value}` : value || tag;
        badgeWrapper.append(badgeLabel);
        fragment.append(badgeWrapper);
    }
    containerElement.classList.add("card__badges");
    if (!tagsConfig) containerElement.classList.add("badges", "badges--top-left");
    containerElement.append(fragment);
}


const $c1e80430a91987d7$var$PRODUCT_SLIDER_TABS_SELECTOR = ".js-tabs";
const $c1e80430a91987d7$var$CARD_BADGES_ENTITY = "ss-card-badges";
const $c1e80430a91987d7$var$CARD_BADGES_SELECTOR = `[data-entity="${$c1e80430a91987d7$var$CARD_BADGES_ENTITY}"]`;
const $c1e80430a91987d7$var$PRODUCT_SLIDE_SELECTOR = "swiper-slide[data-product-handle]";
const $c1e80430a91987d7$var$SEARCHSPRING_API_URL = "https://api.searchspring.net/api/search/search.json";
const $c1e80430a91987d7$var$SEARCHSPRING_FETCH_TIMEOUT_MS = 8000;
function $c1e80430a91987d7$var$fetchSearchspringJson(url) {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(()=>controller.abort(), $c1e80430a91987d7$var$SEARCHSPRING_FETCH_TIMEOUT_MS);
    return fetch(url, {
        credentials: "omit",
        signal: controller.signal
    }).then((response)=>response.ok ? response.json() : null).catch(()=>null).finally(()=>window.clearTimeout(timeoutId));
}
function $c1e80430a91987d7$var$getSiteIdFromContainer(tabsContainer) {
    return tabsContainer.dataset.siteId?.trim() ?? "";
}
function $c1e80430a91987d7$var$getAllHandlesInContainer(productSlideElements) {
    const productHandles = [];
    productSlideElements.forEach((productSlideElement)=>{
        const productHandle = productSlideElement.dataset.productHandle?.trim() ?? "";
        if (!productHandle) return;
        productHandles.push(productHandle);
    });
    return productHandles;
}
async function $c1e80430a91987d7$var$fetchBadgesForHandles(siteId, handles) {
    if (!handles.length) return new Map();
    const queryParams = new URLSearchParams();
    queryParams.set("siteId", siteId);
    queryParams.set("resultsFormat", "native");
    queryParams.set("resultsPerPage", String(handles.length));
    const handleFilterParam = "filter.handle";
    handles.forEach((productHandle)=>queryParams.append(handleFilterParam, productHandle));
    const requestUrl = `${$c1e80430a91987d7$var$SEARCHSPRING_API_URL}?${queryParams.toString()}`;
    const responseData = await $c1e80430a91987d7$var$fetchSearchspringJson(requestUrl);
    const searchResults = responseData?.results ?? [];
    const badgesByProductHandle = new Map();
    searchResults.forEach((result)=>{
        const productHandle = typeof result.handle === "string" ? result.handle : "";
        if (!productHandle || badgesByProductHandle.has(productHandle)) return;
        badgesByProductHandle.set(productHandle, Array.isArray(result.badges) ? result.badges : []);
    });
    return badgesByProductHandle;
}
function $c1e80430a91987d7$var$getOrCreateBadgesRoot(parent) {
    const existingBadgesRoot = parent.querySelector($c1e80430a91987d7$var$CARD_BADGES_SELECTOR);
    if (existingBadgesRoot instanceof HTMLElement) return existingBadgesRoot;
    const badgesRootElement = document.createElement("div");
    badgesRootElement.dataset.entity = $c1e80430a91987d7$var$CARD_BADGES_ENTITY;
    badgesRootElement.className = "ss__pdp-badges";
    badgesRootElement.setAttribute("aria-live", "polite");
    parent.insertBefore(badgesRootElement, parent.firstChild);
    return badgesRootElement;
}
function $c1e80430a91987d7$var$applyBadgesToContainer(productSlideElements, badgesByHandle, tagsConfig) {
    productSlideElements.forEach((productSlideElement)=>{
        const productHandle = productSlideElement.dataset.productHandle?.trim() ?? "";
        if (!productHandle) return;
        const productBadges = badgesByHandle.get(productHandle) ?? [];
        const cardElement = productSlideElement.querySelector(".card__inner, .card") ?? productSlideElement;
        if (!productBadges.length) {
            cardElement.querySelector($c1e80430a91987d7$var$CARD_BADGES_SELECTOR)?.remove();
            return;
        }
        const badgesRootElement = $c1e80430a91987d7$var$getOrCreateBadgesRoot(cardElement);
        badgesRootElement.replaceChildren();
        (0, $7d1b13016aa3d0bd$export$1a6553668c5e7a2c)(badgesRootElement, productBadges, tagsConfig);
    });
}
async function $c1e80430a91987d7$var$runForContainer(tabsContainer) {
    const searchspringSiteId = $c1e80430a91987d7$var$getSiteIdFromContainer(tabsContainer);
    if (!searchspringSiteId) return;
    const productSlideElements = tabsContainer.querySelectorAll($c1e80430a91987d7$var$PRODUCT_SLIDE_SELECTOR);
    if (!productSlideElements.length) return;
    const productHandles = $c1e80430a91987d7$var$getAllHandlesInContainer(productSlideElements);
    if (!productHandles.length) return;
    const [badgesByHandle, tagsConfig] = await Promise.all([
        $c1e80430a91987d7$var$fetchBadgesForHandles(searchspringSiteId, productHandles),
        (0, $7d1b13016aa3d0bd$export$8545333153626f43)(searchspringSiteId, $c1e80430a91987d7$var$fetchSearchspringJson)
    ]);
    $c1e80430a91987d7$var$applyBadgesToContainer(productSlideElements, badgesByHandle, tagsConfig);
}
function $c1e80430a91987d7$var$mountIn(root) {
    root.querySelectorAll($c1e80430a91987d7$var$PRODUCT_SLIDER_TABS_SELECTOR).forEach((container)=>{
        if (!(container instanceof HTMLElement)) return;
        $c1e80430a91987d7$var$runForContainer(container);
    });
}
$c1e80430a91987d7$var$mountIn(document);


const $9eeffc371cf003ec$var$ROOT_SELECTOR = ".collection-seo-description";
const $9eeffc371cf003ec$var$TOGGLE_SELECTOR = ".collection-seo-description__toggle";
const $9eeffc371cf003ec$var$TEXT_SELECTOR = ".collection-seo-description__text";
const $9eeffc371cf003ec$var$OPEN_CLASS = "is-open";
const $9eeffc371cf003ec$var$READY_CLASS = "is-ready";
const $9eeffc371cf003ec$var$initCollectionSeoDescription = (root)=>{
    const section = root.querySelector($9eeffc371cf003ec$var$ROOT_SELECTOR);
    if (!section) return;
    const btn = section.querySelector($9eeffc371cf003ec$var$TOGGLE_SELECTOR);
    if (!btn) return;
    const id = btn.getAttribute("aria-controls");
    const wrap = id ? document.getElementById(id) : null;
    if (!wrap) return;
    const text = wrap.querySelector($9eeffc371cf003ec$var$TEXT_SELECTOR);
    if (!text) return;
    wrap.classList.remove($9eeffc371cf003ec$var$OPEN_CLASS);
    btn.setAttribute("aria-expanded", "false");
    wrap.setAttribute("aria-hidden", "false");
    const isClamped = ()=>text.scrollHeight > text.clientHeight + 1;
    if (!isClamped()) return;
    btn.classList.add($9eeffc371cf003ec$var$READY_CLASS);
    btn.addEventListener("click", ()=>{
        const nextExpanded = btn.getAttribute("aria-expanded") !== "true";
        btn.setAttribute("aria-expanded", String(nextExpanded));
        wrap.classList.toggle($9eeffc371cf003ec$var$OPEN_CLASS, nextExpanded);
        wrap.setAttribute("aria-hidden", "false");
    });
};
$9eeffc371cf003ec$var$initCollectionSeoDescription(document);
document.addEventListener("shopify:section:load", (e)=>{
    const target = e.target;
    if (target instanceof HTMLElement) $9eeffc371cf003ec$var$initCollectionSeoDescription(target);
});



const $5fe3604b02912324$var$BADGES_SELECTOR = '[data-entity="ss-badges"]';
const $5fe3604b02912324$var$FETCH_TIMEOUT_MS = 8000;
const $5fe3604b02912324$var$fetchJson = (url)=>{
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), $5fe3604b02912324$var$FETCH_TIMEOUT_MS);
    return fetch(url, {
        credentials: "omit",
        signal: controller.signal
    }).then((response)=>response.ok ? response.json() : null).catch(()=>null).finally(()=>clearTimeout(timeoutId));
};
async function $5fe3604b02912324$var$fetchBadges(siteId, sku) {
    const encodedSiteId = encodeURIComponent(siteId);
    const encodedSku = encodeURIComponent(sku);
    const url = `https://api.searchspring.net/api/search/search.json?siteId=${encodedSiteId}&resultsFormat=native&resultsPerPage=10&q=${encodedSku}`;
    const data = await $5fe3604b02912324$var$fetchJson(url);
    const results = data?.results;
    if (!results || !results.length) return [];
    const exactMatch = results.find((result)=>result.sku === sku);
    const source = exactMatch ?? results[0];
    return source.badges && Array.isArray(source.badges) ? source.badges : [];
}
async function $5fe3604b02912324$var$mountBadges(containerElement) {
    if (containerElement.dataset.ssBadgesBound === "true" || containerElement.childElementCount) return;
    const { id: sku, siteId: siteId } = containerElement.dataset;
    if (!sku || !siteId) return;
    containerElement.dataset.ssBadgesBound = "true";
    const [badges, tagsConfig] = await Promise.all([
        $5fe3604b02912324$var$fetchBadges(siteId, sku),
        (0, $7d1b13016aa3d0bd$export$8545333153626f43)(siteId, $5fe3604b02912324$var$fetchJson)
    ]);
    if (badges.length) (0, $7d1b13016aa3d0bd$export$1a6553668c5e7a2c)(containerElement, badges, tagsConfig);
}
function $5fe3604b02912324$var$mountBadgesIn(rootNode) {
    rootNode.querySelectorAll($5fe3604b02912324$var$BADGES_SELECTOR).forEach((element)=>{
        if (element instanceof HTMLElement) $5fe3604b02912324$var$mountBadges(element);
    });
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>$5fe3604b02912324$var$mountBadgesIn(document));
else $5fe3604b02912324$var$mountBadgesIn(document);
document.addEventListener("shopify:section:load", (event)=>{
    const targetElement = event.target;
    if (targetElement instanceof HTMLElement) $5fe3604b02912324$var$mountBadgesIn(targetElement);
});


parcelRequire("695Bn");
const $a970e57ee1a335bc$var$WISHLIST_ITEM_SELECTOR = ".swym-wishlist-item";
const $a970e57ee1a335bc$var$WISHLIST_IMAGE_LINK_SELECTOR = ".swym-wishlist-image-wrapper";
const $a970e57ee1a335bc$var$WISHLIST_VARIANT_TITLE_SELECTOR = ".swym-variant-title";
const $a970e57ee1a335bc$var$WISHLIST_SKU_BOUND_KEY = "wishlistSkuBound";
const $a970e57ee1a335bc$var$SWYM_WISHLIST_PRODUCTS_KEY = "swym-products";
let $a970e57ee1a335bc$var$cachedWishlistProducts;
const $a970e57ee1a335bc$var$isObject = (value)=>typeof value === "object" && value !== null;
const $a970e57ee1a335bc$var$isSwymWishlistStorage = (value)=>$a970e57ee1a335bc$var$isObject(value) && "all" in value;
const $a970e57ee1a335bc$var$isSwymWishlistRawItem = (value)=>$a970e57ee1a335bc$var$isObject(value);
const $a970e57ee1a335bc$var$readVariantId = (value)=>{
    if (value == null) return null;
    if (typeof value === "number") return String(value);
    if (typeof value === "string") {
        const trimmed = value.trim();
        return trimmed || null;
    }
    return null;
};
const $a970e57ee1a335bc$var$loadWishlistProducts = ()=>{
    if ($a970e57ee1a335bc$var$cachedWishlistProducts !== undefined) return $a970e57ee1a335bc$var$cachedWishlistProducts;
    if (typeof window === "undefined" || !window.localStorage) return $a970e57ee1a335bc$var$cachedWishlistProducts = null;
    const raw = window.localStorage.getItem($a970e57ee1a335bc$var$SWYM_WISHLIST_PRODUCTS_KEY);
    if (!raw) return $a970e57ee1a335bc$var$cachedWishlistProducts = null;
    try {
        const parsed = JSON.parse(raw);
        if (!$a970e57ee1a335bc$var$isSwymWishlistStorage(parsed) || !Array.isArray(parsed.all)) return $a970e57ee1a335bc$var$cachedWishlistProducts = null;
        const products = parsed.all.reduce((acc, item)=>{
            if (!$a970e57ee1a335bc$var$isSwymWishlistRawItem(item) || typeof item.sku !== "string") return acc;
            const sku = item.sku.trim();
            if (!sku) return acc;
            acc.push({
                sku: sku,
                variantId: $a970e57ee1a335bc$var$readVariantId(item.epi)
            });
            return acc;
        }, []);
        return $a970e57ee1a335bc$var$cachedWishlistProducts = products.length ? products : null;
    } catch  {
        return $a970e57ee1a335bc$var$cachedWishlistProducts = null;
    }
};
const $a970e57ee1a335bc$var$getVariantIdFromUrl = (url)=>{
    const value = url.searchParams.get("variant")?.trim() ?? "";
    return value || null;
};
const $a970e57ee1a335bc$var$findSkuForVariant = (variantId)=>{
    if (!variantId) return null;
    const products = $a970e57ee1a335bc$var$loadWishlistProducts();
    if (!products) return null;
    return products.find((product)=>product.variantId === variantId) ?? null;
};
const $a970e57ee1a335bc$var$enhanceWishlistItem = (itemElement)=>{
    if (itemElement.dataset[$a970e57ee1a335bc$var$WISHLIST_SKU_BOUND_KEY] === "true") return;
    const linkElement = itemElement.querySelector($a970e57ee1a335bc$var$WISHLIST_IMAGE_LINK_SELECTOR);
    const skuElement = itemElement.querySelector($a970e57ee1a335bc$var$WISHLIST_VARIANT_TITLE_SELECTOR);
    if (!(linkElement instanceof HTMLAnchorElement)) return;
    if (!(skuElement instanceof HTMLElement)) return;
    const existingText = skuElement.textContent?.trim() || "";
    let url;
    try {
        url = new URL(linkElement.href, window.location.origin);
    } catch  {
        return;
    }
    const fromSwym = $a970e57ee1a335bc$var$findSkuForVariant($a970e57ee1a335bc$var$getVariantIdFromUrl(url));
    if (!fromSwym) return;
    const { sku: sku, variantId: variantId } = fromSwym;
    if (variantId) itemElement.dataset.variantId = variantId;
    itemElement.dataset.sku = sku;
    itemElement.dataset[$a970e57ee1a335bc$var$WISHLIST_SKU_BOUND_KEY] = "true";
    const container = document.getElementById("swym-wishlist-render-container");
    const label = container instanceof HTMLElement ? container.dataset.labelSku?.trim() || null : null;
    const skuText = label ? `${label}: ${sku}` : sku;
    skuElement.textContent = existingText ? `${existingText} \xb7 ${skuText}` : skuText;
};
const $a970e57ee1a335bc$var$enhanceWishlistIn = (rootNode)=>{
    rootNode.querySelectorAll($a970e57ee1a335bc$var$WISHLIST_ITEM_SELECTOR).forEach((element)=>{
        if (element instanceof HTMLElement) $a970e57ee1a335bc$var$enhanceWishlistItem(element);
    });
};
const $a970e57ee1a335bc$var$observeWishlist = ()=>{
    const container = document.getElementById("swym-wishlist-render-container");
    if (!(container instanceof HTMLElement)) return;
    const observer = new MutationObserver(()=>{
        $a970e57ee1a335bc$var$enhanceWishlistIn(container);
    });
    observer.observe(container, {
        childList: true,
        subtree: true
    });
};
const $a970e57ee1a335bc$var$handleWishlistItemClick = (event)=>{
    const container = document.getElementById("swym-wishlist-render-container");
    if (!(container instanceof HTMLElement)) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!container.contains(target)) return;
    const button = target.closest("button");
    if (button && button.matches(".swym-delete-btn, .swym-add-to-cart-btn, .swym-wishlist-add-to-cart-btn")) return;
    const itemElement = target.closest($a970e57ee1a335bc$var$WISHLIST_ITEM_SELECTOR);
    if (!(itemElement instanceof HTMLElement)) return;
    const imageLink = itemElement.querySelector($a970e57ee1a335bc$var$WISHLIST_IMAGE_LINK_SELECTOR);
    if (!(imageLink instanceof HTMLAnchorElement)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    window.location.href = imageLink.href;
};
const $a970e57ee1a335bc$var$initWishlistNavigation = ()=>{
    document.addEventListener("click", $a970e57ee1a335bc$var$handleWishlistItemClick, true);
};
$a970e57ee1a335bc$var$enhanceWishlistIn(document);
$a970e57ee1a335bc$var$observeWishlist();
$a970e57ee1a335bc$var$initWishlistNavigation();


parcelRequire("9ei6z");
const $ac617f9c4278b30e$var$TOGGLE_SELECTOR = ".seo-content__text-toggle";
const $ac617f9c4278b30e$var$COLLAPSIBLE_CLASS = "is-collapsible";
const $ac617f9c4278b30e$var$OPEN_CLASS = "is-open";
const $ac617f9c4278b30e$var$initSeoContent = ()=>{
    const btn = document.querySelector($ac617f9c4278b30e$var$TOGGLE_SELECTOR);
    if (!(btn instanceof HTMLButtonElement)) return;
    btn.classList.add("is-ready");
    const id = btn.getAttribute("aria-controls");
    const wrap = id ? document.getElementById(id) : null;
    if (!wrap) return;
    wrap.classList.add($ac617f9c4278b30e$var$COLLAPSIBLE_CLASS);
    const expanded = btn.getAttribute("aria-expanded") === "true";
    wrap.setAttribute("aria-hidden", String(!expanded));
    if (expanded) {
        wrap.classList.add($ac617f9c4278b30e$var$OPEN_CLASS);
        wrap.style.maxHeight = `${wrap.scrollHeight}px`;
    }
    btn.addEventListener("click", ()=>{
        const isExpanded = btn.getAttribute("aria-expanded") === "true";
        if (!isExpanded) {
            btn.setAttribute("aria-expanded", "true");
            wrap.classList.add($ac617f9c4278b30e$var$OPEN_CLASS);
            wrap.setAttribute("aria-hidden", "false");
            requestAnimationFrame(()=>{
                wrap.style.maxHeight = `${wrap.scrollHeight}px`;
            });
        } else {
            btn.setAttribute("aria-expanded", "false");
            wrap.style.maxHeight = `${wrap.scrollHeight}px`;
            requestAnimationFrame(()=>{
                wrap.classList.remove($ac617f9c4278b30e$var$OPEN_CLASS);
                wrap.setAttribute("aria-hidden", "true");
                wrap.style.maxHeight = "";
            });
        }
        const labelMore = btn.dataset.labelMore;
        const labelLess = btn.dataset.labelLess;
        const span = btn.querySelector("span");
        if (span && labelMore && labelLess) span.textContent = isExpanded ? labelMore : labelLess;
    });
};
$ac617f9c4278b30e$var$initSeoContent();


parcelRequire("aKoSb");

})();
//# sourceMappingURL=global.js.map
